/* eslint-disable max-len */
import React, { createContext, useCallback, useMemo, useState } from 'react';
import FeedCards from '../LeftPart/FeedCards';
import Comments from '../Reusable/Comments';

export const feedActionContextFromExternal = createContext <any>({});
export interface FeedAction {
    comments?: any // to display feed comments on right side
    all_event_comment?: any;
    new_feed?: any; // for patching new feed to feed list
    remove_feed?:any // for removing a particular feed from list (either pass index in obj or the original obj)
    bookmark_add?: any; // for appending new bookmarked feed side bookmark component
    bookmark_remove?: any; // for appending new bookmarked feed side bookmark component
    report_feed?:any;// for reporting a news feed
    report_tag?:any;// for showing a tag after reporting a feed and to remove the feed from that list
    feedCommentCount?:any; // to display feed comments count
	comments_add?:any;
}

const ExFeedAccess = ({ requestT, from }) =>
{
	const [ feedAction, setFeedAction ] = useState< FeedAction >({});
	const [ feedCardActn, setFeedCardActn ] = useState<any>([]);

	const handleFeedAction = useCallback((action: 'append' | 'remove', key:string, value?:any) =>
	{
		if (action === 'append') setFeedAction((prev) => ({ ...prev, [key]: value }));
		else if (action === 'remove') setFeedAction((prev) => ({ ...prev, [key]: null }));
	}, []);

	const contextValue = useMemo(() => ({
		feedAction,
		handleFeedAction,
		feedCardActn,
		setFeedCardActn
	}), [ feedAction, handleFeedAction ]);

	const openComment = Array.isArray(feedCardActn) && feedCardActn?.length > 0 && feedCardActn?.[0] === 'comments';

	const handleClose = () =>
	{
		setFeedCardActn([]);
		handleFeedAction('append', 'comments_add', 0);
	};

	return (
		<>
			<feedActionContextFromExternal.Provider value={contextValue}>
				{/* Feed Card Access for out side modules */}
				<FeedCards
					contextT={'external'}
					requestT={requestT}
					from={from}
				/>
				<button tabIndex={0} className={openComment ? 'overlaySlider fadeInOverlay' : ''} onClick={() => handleClose()} />
				<div className={openComment ? 'flexCol fxdSocialMediaSlider slideIn' : 'flexCol fxdSocialMediaSlider'} >
					<Comments from='feeds' />
				</div>
			</feedActionContextFromExternal.Provider>
		</>
	);
};

export default ExFeedAccess;